<template>
    <div>
        <transition name="fade">
            <div class="v-modal-overlay" v-if="show"></div>
        </transition>
        <transition name="slide-top">
            <div class="v-modal-container" v-if="show">
                <div class="v-modal-overlay-close" @click="close()"></div>
                <div class="v-modal">
                    <div class="v-modal-header d-flex justify-content-between align-items-center" v-if="showHeader">
                        <strong class="text-uppercase"><slot name="header"></slot></strong>
                        <div class="v-modal-header-close" @click="close()"><i class="fas fa-times"></i></div>
                    </div>
                    <div class="v-modal-body">
                        <slot name="body"></slot>
                    </div>
                    <div class="v-modal-footer" v-if="showFooter">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    emits: ['close'],
    props: {
        showHeader: {
            type: Boolean,
            default: true
        },
        showFooter: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            show: false,
        }
    },

    methods: {
        close() {
            this.$emit('close');
            this.show = false;
        },
        open() {
            this.show = true;
        }
    },

    watch: {
        show: function (value) {
            if (value) {
                document.body.classList.add('no-scroll');
            } else {
                document.body.classList.remove('no-scroll');
            }
        }
    },
}
</script>

<style scoped lang="scss">
    .v-modal-overlay, .v-modal-container, .v-modal-overlay-close {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .v-modal-overlay {
        z-index: 99999998;
        transition: opacity .3s;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .v-modal-container {
        z-index: 99999999;
        transition: transform .5s;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: auto;
        padding: 5rem 0;
    }

    .v-modal-overlay-close {
        z-index: 0;
    }

    .v-modal {
        z-index: 1;
        width: 80%;
        max-width: 600px;
        background-color: white;
        border: 1.5px solid rgba(0, 0, 0, 0.1);
        margin-bottom: 5rem;
        position: relative;

        &-header, &-body, &-footer {
            padding-left: 2rem;
            padding-right: 2rem;
        }

        &-header {
            padding-right: 0;
            border-bottom: 1.5px solid rgba(0, 0, 0, 0.1);

            &-close {
                position: relative;
                padding: 1rem 1.375rem;
                cursor: pointer;

                i {
                    display: inline-block;
                    margin-top: .125rem;
                    opacity: .3;
                    transition: opacity .3s;
                }

                &:hover i {
                    opacity: .7;
                }

                &:before {
                    position: absolute;
                    content: '';

                    top: 0;
                    left: 0;
                    bottom: 0;
                    border-left: 1.5px solid rgba(0, 0, 0, 0.1);
                }
            }
        }

        &-body {
            padding-top: 2rem;
            padding-bottom: 2rem;
        }
    }

    .slide-top-enter-from, .slide-top-leave-to {
        transform: translateY(-100%);
    }

    .slide-top-enter-to, .slide-top-leave-from, .slide-top-enter-to, .slide-top-leave-from {
        transform: translateY(0);
    }

    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }

    .fade-enter-to, .fade-leave-from, .fade-enter-to, .fade-leave-from {
        opacity: 1;
    }
</style>
